import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=05920520&"
import script from "./CourseDetails.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseDetails.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports